import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class CountsList extends Component {
  state = {
    counts: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
  };

  componentDidMount() {
    this.getAllCounts(this.state.page_no, this.state.per_page);
  }

  getAllCounts = (page = 1, limit = 20) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    axios
      .get(`${Constants.getUrls.getAllCounts}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data?.status === "success") {
          // support two possible server shapes:
          // 1) resp.data.data.docs + pagination fields (like mongoose-paginate-v2)
          // 2) resp.data.data (array) + resp.data.pagination (custom)
          let data = resp.data.data;
          let counts = [];
          let pagination = { ...this.state.pagination };

          if (data?.docs) {
            // shape from mongoose-paginate-v2
            counts = data.docs;
            pagination = {
              page: data.page,
              limit: data.limit,
              totalDocs: data.totalDocs,
              totalPages: data.totalPages,
              hasNextPage: data.hasNextPage,
              hasPrevPage: data.hasPrevPage,
              nextPage: data.nextPage,
              prevPage: data.prevPage,
            };
          } else if (Array.isArray(data)) {
            // simple array + custom pagination returned separately
            counts = data;
            const p = resp.data?.pagination || {};
            pagination = {
              page: p.page || page,
              limit: p.limit || limit,
              totalDocs: p.total || data.length,
              totalPages: p.totalpage || Math.ceil((p.total || data.length) / limit),
              hasNextPage: !!p.nextpage,
              hasPrevPage: !!p.prevpage,
              nextPage: p.nextpage || null,
              prevPage: p.prevpage || null,
            };
          } else if (data) {
            // sometimes backend returns an object with `rows` or `items`
            counts = data.rows || data.items || [];
            const p = data.pagination || resp.data.pagination || {};
            pagination = {
              page: p.page || page,
              limit: p.limit || limit,
              totalDocs: p.total || counts.length,
              totalPages: p.totalpage || Math.ceil((p.total || counts.length) / limit),
              hasNextPage: !!p.nextpage,
              hasPrevPage: !!p.prevpage,
              nextPage: p.nextpage || null,
              prevPage: p.prevpage || null,
            };
          }

          this.setState({
            counts,
            pagination,
            page_no: pagination.page,
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            message: resp.data?.message || "Failed to load counts",
            loading: false,
            notiColor: "warning",
          });
        }
      })
      .catch(() => {
        this.setState({
          notification: true,
          message: "Something went wrong!",
          loading: false,
          notiColor: "warning",
        });
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllCounts(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllCounts(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this count?")) return;

    axios
      .delete(Constants.deleteUrls.deleteCount + id)
      .then((resp) => {
        this.setState(
          {
            notification: true,
            notiColor: "success",
            message: resp.data?.message || "Count deleted",
          },
          () => {
            // refresh current page
            this.getAllCounts(this.state.pagination.page, this.state.per_page);
          }
        );
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
        }, 2500);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Delete failed",
        });
      });
  };

  render() {
    const { counts, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                About Us Counts List
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right">
              <Link to="/addcount">
                <MDButton variant="contained" size="small" color="primary">
                  Create New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : counts && counts.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Title", accessor: "title" },
                      { Header: "Description", accessor: "description" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: counts.map((count, index) => ({
                      serial: (pagination.page - 1) * pagination.limit + (index + 1),
                      title: count.title,
                      description: (
                        <div
                          style={{ maxWidth: 400, whiteSpace: "normal", wordBreak: "break-word" }}
                        >
                          {count.description || "—"}
                        </div>
                      ),
                      action: (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          {/* Edit */}
                          <Tooltip title="Edit Count" placement="top">
                            <Link
                              to={{
                                pathname: `/updateCount/${count._id}`,
                                state: { data: count },
                              }}
                            >
                              <IconButton color="info" size="small">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          {/* Delete */}
                          <Tooltip title="Delete Count" placement="top">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(count._id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Data Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Counts Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
